module.exports = __webpack_public_path__ + "img/main-banner-mobile2.7171b248.png";